/**
 * The origins an OAuth callback message may come from: the app's own origin,
 * and the API's when it is served from another one (the callback page is
 * rendered by the API and posts back to the opener).
 */
export function trustedOAuthOrigins(apiUrl: string | undefined = import.meta.env.VITE_API_URL): string[] {
  const origins = [window.location.origin];
  if (apiUrl) {
    try {
      origins.push(new URL(apiUrl, window.location.origin).origin);
    } catch {
      /* not a URL: only the app's own origin is trusted */
    }
  }
  return origins;
}

/**
 * Whether a `message` event is the OAuth callback from the popup this window
 * opened: of the right type, sent by that popup, from a trusted origin. Any
 * other window posting an `oauth-callback` is ignored.
 */
export function isOAuthCallbackFrom(e: MessageEvent, popup: Window | null, origins: readonly string[] = trustedOAuthOrigins()): boolean {
  const data = e.data as { type?: unknown } | null;
  if (!data || data.type !== 'oauth-callback') return false;
  if (!popup || e.source !== popup) return false;
  return origins.includes(e.origin);
}
